import { FC } from 'react';

import { NavigationItem } from '@telialt/models/src/Navigation';

import { MobileMenuItemContent, StyledMenuLink } from '../MobileMenu/MobileMenu.styles';
import { MobileMenuItemComponentB2b } from './MobileMenuItemComponentB2b';
import { MobileMenuItemComponentExManoTeo } from './MobileMenuItemComponentExManoTeo';
import { MobileMenuItemComponentMandates } from './MobileMenuItemComponentMandates';
import { MobileMenuItemComponentMobility } from './MobileMenuItemComponentMobility';
import { MobileMenuItemComponentStrong } from './MobileMenuItemComponentStrong';
import { MobileMenuItemComponentUpsell } from './MobileMenuItemComponentUpsell';

type Props = {
    item: NavigationItem;
    menuLevel: number;
};

export const MobileMenuItemComponent: FC<Props> = ({ item, menuLevel }) => {
    switch (item.component) {
        case 'SS_B2B':
            return <MobileMenuItemComponentB2b item={item} menuLevel={menuLevel} />;
        case 'SS_MOBILITY':
            return <MobileMenuItemComponentMobility item={item} menuLevel={menuLevel} />;
        case 'SS_STRONG':
        case 'SS_DOCUMENTS':
            return <MobileMenuItemComponentStrong item={item} menuLevel={menuLevel} />;
        case 'SS_B2B_UPSELL':
            return <MobileMenuItemComponentUpsell item={item} menuLevel={menuLevel} />;
        case 'SS_MANDATES':
            return <MobileMenuItemComponentMandates item={item} menuLevel={menuLevel} />;
        case 'SS_EXMANOTEO':
            return <MobileMenuItemComponentExManoTeo item={item} menuLevel={menuLevel} />;
        default:
            return (
                <StyledMenuLink as="button" type="button" $colorOption={item.colorOption}>
                    <MobileMenuItemContent>
                        {item.title} - [{item.component}]
                    </MobileMenuItemContent>
                </StyledMenuLink>
            );
    }
};
